import { useEffect, useRef, useCallback } from 'react';
import { supabase } from '../utils/supabase';

export function useRetroRealtime(sessionId, { onSession, onCards, onActions, onVotes, onParticipants } = {}) {
  const channelRef = useRef(null);

  const subscribe = useCallback(() => {
    if (!sessionId) return;
    const channel = supabase.channel(`retro:${sessionId}`)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'retro_sessions', filter: `id=eq.${sessionId}` }, () => onSession?.())
      .on('postgres_changes', { event: '*', schema: 'public', table: 'retro_cards', filter: `session_id=eq.${sessionId}` }, () => onCards?.())
      .on('postgres_changes', { event: '*', schema: 'public', table: 'retro_actions', filter: `session_id=eq.${sessionId}` }, () => onActions?.())
      .on('postgres_changes', { event: '*', schema: 'public', table: 'retro_votes', filter: `session_id=eq.${sessionId}` }, () => onVotes?.())
      .on('postgres_changes', { event: '*', schema: 'public', table: 'retro_participants', filter: `session_id=eq.${sessionId}` }, () => onParticipants?.())
      .subscribe();
    channelRef.current = channel;
  }, [sessionId, onSession, onCards, onActions, onVotes, onParticipants]);

  useEffect(() => {
    subscribe();
    return () => { if (channelRef.current) supabase.removeChannel(channelRef.current); };
  }, [subscribe]);
}
